import React, { useEffect, useState, useRef, useImperativeHandle } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import formStyles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import CustomDialog from "components/CustomDialog/CustomDialog.js";
import Button from "components/CustomButtons/CustomButton";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import SelectCustomerModal from "components/Customer/SelectCustomerModal";
import CustomModal from "components/CustomModal/Modal.js";
import CustomButton from "components/CustomButtons/CustomButton";

import {
  isAgent,
} from "components/Utils/utils.js";

// Services
import { checkExistCustomer } from "views/Services/ClientService";

import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const useStylesPrincipal = makeStyles(stylePrincipal);
const useStyles = makeStyles(styles);
const useFormStyles = makeStyles(formStyles);
let current_date = new Date();

const Step1 = React.forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const [checked, setChecked] = React.useState([]);
  const { submitAction, previewAction, getCustomer, isLogged } = props;
  const routeParams = useParams();
  const { type } = routeParams;
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const blurTimeout = useRef(null);
  const [addressSelected, setAddressSelected] = useState(false);
  const [open, setOpen] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [modalDriverExists, setModalDriverExists] = useState(false);
  const [messageModalCheck, setMessageModalCheck] = useState("");
  const classesPrincipal = useStylesPrincipal();
  const [oneClicValidate, setOneClicValidate] = useState(false);
  const [oneClickLogin, setOneClickLogin] = useState(false);
  const [states, setStates] = useState([]);
  const [dlstates, setDLStates] = useState([]);
  const [checkedAccountStep, setCheckedAccountStep] = useState(false);
  const [openCustomerSelectModal, setOpenCustomerSelectModal] = useState(false);
  const [preferredLanguage, setPreferredLanguage] = useState("");
  const [fieldEndorsement, setFieldEndorsement] = useState("");
  const [loginCredentials, setLoginCredentials] = useState({
    login: "",
    password: "",
  });
  const [sended, setSended] = useState(false);
  const classes = useStyles();
  const [vehicleData, setVehicleData] = useState({ vehtype: 1, agent: 441 });
  const [personData, setPersonData] = useState({
    clientnumber: "New Client",
    vehtype: 1,
    agent: 441,
  });
  const [valores, setValores] = useState([]);
  useEffect(() => {
    if (props.data) {
      setData(props.data);
      setValuesForTypeVehicle(1, {});
      checkEndorsementType(props.data.coverages.endorsementtype);
    }
    if (props.personData) {
      setPersonData(props.personData);
      if (isAgent) {
        setPreferredLanguage(props.personData.preferred_language);
      } else {
        setPreferredLanguage(i18n.language);
      }
      if (props.personData?.dl_country_id) {
        setDLStates(
          props.data.catalogs.states.filter(
            (e) => e.country_id == props.personData?.dl_country_id
          )
        );
      }
      if (props.personData?.country_id) {
        setStates(
          props.data.catalogs.states.filter(
            (e) => e.country_id == props.personData?.country_id
          )
        );
      }
    }
    if (props.vehicleData) {
      setVehicleData(props.vehicleData);
    }
    if (localStorage.getItem("userToken") !== null) {
      setCheckedAccountStep(true);
    }
  }, [props]);

  const checkEndorsementType = (endorsementType) => {
    if (endorsementType == "Change Client Name") {
      setFieldEndorsement("name");
    }
    if (endorsementType == "Change Client Address") {
      setFieldEndorsement("address");
    }
    if (endorsementType == "Change Client EMail Address") {
      setFieldEndorsement("email");
    }
    if (endorsementType == "Change Client Phone Number") {
      setFieldEndorsement("phone");
    }
    if (endorsementType == "Change Client Insurance Company Name") {
      setFieldEndorsement("insurance_company");
    }
    if (endorsementType == "Change Client Insurance Policy Number") {
      setFieldEndorsement("insurance_policy");
    }
    if (endorsementType == "Change Client Additional Insured") {
      setFieldEndorsement("additionalInsured");
    }
    if (endorsementType == "Change Client State") {
      setFieldEndorsement("state");
    }
    if (endorsementType == "Change Client Country") {
      setFieldEndorsement("country");
    }
    if (endorsementType == "Change Client City") {
      setFieldEndorsement("city");
    }
    if (endorsementType == "Change Client Zip Code") {
      setFieldEndorsement("zipcode");
    }
    if (endorsementType == "Change Client DL License Number") {
      setFieldEndorsement("dl_license");
    }
    if (endorsementType == "Change Client DL State") {
      setFieldEndorsement("dl_state");
    }
    if (endorsementType == "Change Client DL Country") {
      setFieldEndorsement("dl_country");
    }
  };

  useImperativeHandle(ref, () => ({
    saveStepComplete,
  }));

  const saveStepComplete = (save) => {
    handleSubmitStep(save);
  };

  useEffect(() => {
    const handleLangChanged = (lng) => {
      setPreferredLanguage(lng);
    };

    i18n.on("languageChanged", handleLangChanged);

    return () => {
      i18n.off("languageChanged", handleLangChanged);
    };
  }, [i18n]);

  useEffect(() => {
    if (type === "oneClickLogin") {
      setOneClickLogin(true);
    }

    if (window.location.href.includes("checkTokenOneClick")) {
      setOneClicValidate(true);
      validateToken();
    }
  }, [dispatch]);

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setPersonData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name == "additionalInsured") {
      setPersonData((prevData) => ({
        ...prevData,
        additional_insured: value,
      }));
    }
    if (name === "country_id") {
      setStates(data.catalogs.states.filter((e) => e.country_id == value));
    }
    if (name === "dl_country_id") {
      setDLStates(data.catalogs.states.filter((e) => e.country_id == value));
    }
  };

  const checkDriverToValidate = async () => {
    if (
      (!checkedAccountStep && localStorage.getItem("userToken") === null) ||
      isAgent
    ) {
      let type = "driver";
      type =
        personData.dl_number != "" && typeof personData.email != "undefined"
          ? "both"
          : type;
      const resultSubmit = await dispatch(
        checkExistCustomer({
          email: personData.email,
          driver_license: personData.dl_number,
          type: type,
        })
      );
      if (resultSubmit.payload.result) {
        let messageModal = resultSubmit.payload.message;
        messageModal = messageModal.replace(
          "found in the system",
          "already linked to an account"
        );
        if (isAgent) {
          messageModal = messageModal.replace(
            "Please login to purchase a policy",
            'Select "Select customer" and search for the drivers license #'
          );
        }
        setMessageModalCheck(messageModal);
        setModalDriverExists(true);
      } else {
        if (type == "both") {
          setCheckedAccountStep(true);
        }
      }
    }
  };

  useEffect(() => {
    validateComplete(personData);
  }, [personData, checked, checkedAccountStep]);
  const validateComplete = (data) => {
    let reqProperties = [
      "first_name",
      "last_name",
      "country_id",
      "address",
      "city",
      "state_id",
      "zipcode",
      "phone",
      "email",
      "dl_country_id",
      "dl_state_id",
      "dl_number",
    ];
    if (checked.indexOf(1) === -1) {
      reqProperties = [
        "first_name",
        "last_name",
        "address",
        "email",
        "phone",
        "dl_country_id",
        "dl_state_id",
        "dl_number",
        "country_id",
      ];
    }

    let allPropertiesValid = reqProperties.every((prop) => {
      if (prop === "email") {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(data[prop]);
      }
      const valueProp =
        typeof data[prop] === "string" ? data[prop].trim() : data[prop];
      return valueProp !== undefined && valueProp !== null && valueProp !== "";
    });

    allPropertiesValid = !checkedAccountStep ? false : allPropertiesValid;

    setIsCompleted(allPropertiesValid);
  };

  const setValuesForTypeVehicle = (type, vehData) => {
    let limitValue = 300000;
    type = parseInt(type);
    if ([1, 7, 13].includes(type)) {
      limitValue = 100000;
    }
    if (type == 5) {
      limitValue = 50000;
    }
    if (type == 11) {
      limitValue = 40000;
    }
    if (
      [10, 12].includes(type) ||
      current_date.getFullYear() - vehData.year_vehicle > 25
    ) {
      limitValue = 0;
    }
    formatValueField(limitValue);
  };

  const formatValueField = (limitValue) => {
    if (limitValue == 0) {
      let vehicleDataToEdit = { ...vehicleData };
      vehicleDataToEdit.value = 0;
      setVehicleData(vehicleDataToEdit);
    }
    const arreglov = [];
    for (let index = 0; index <= limitValue; index += 1000) {
      if (index === 0) {
        arreglov.push({ value: index, traduccion: "$0 - Liability only" });
      } else {
        index >= 3000 &&
          arreglov.push({ value: index, traduccion: USDollar.format(index) });
      }
    }
    setValores(arreglov);
  };
  const handleSubmitStep = async (save) => {
    let currentPersonData = { ...personData };
    currentPersonData.preferred_language = preferredLanguage;
    submitAction(currentPersonData, vehicleData, true, save);
  };
  const handlePreviewAction = async (event) => {
    previewAction(personData);
  };
  const handleToggle = (event, value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };
  const [autocomplete, setAutocomplete] = useState(null);

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    clearTimeout(blurTimeout.current);
    if (autocomplete) {
      const place = autocomplete.getPlace();
      const formattedAddress = place.formatted_address || "";
      const addressComponents = place.address_components || [];
      const getAddressComponent = (type) => {
        const component = addressComponents.find((comp) =>
          comp.types.includes(type)
        );
        return component ? component.long_name : "";
      };

      const countryName = getAddressComponent("country");
      const stateShortName = getAddressComponent("administrative_area_level_1");
      const street = `${getAddressComponent(
        "street_number"
      )} ${getAddressComponent("route")}`.trim();
      const city = getAddressComponent("locality");
      const postalCode = getAddressComponent("postal_code");
      let findCounty = countryName;
      const usaVariants = [
        "estados unidos",
        "estados unidos de america",
        "united states",
        "united states of america",
        "usa",
        "eeuu",
        "e.e.u.u.",
      ];

      if (
        usaVariants.some(
          (variant) => removeAccents(variant) === removeAccents(countryName)
        )
      ) {
        findCounty = "USA";
      }
      const country = data.catalogs.countries.find(
        (item) => removeAccents(item.name) === removeAccents(findCounty)
      );
      const state = data.catalogs.states.find(
        (item) =>
          removeAccents(item.name) === removeAccents(stateShortName) &&
          item.country_id === (country ? country.id : null)
      );
      handleFormChange({
        target: { name: "addressG", value: formattedAddress },
      });
      handleFormChange({
        target: {
          name: "country_id",
          value: country ? country.id : "",
        },
      });
      handleFormChange({
        target: {
          name: "dl_country_id",
          value: country ? country.id : "",
        },
      });
      handleFormChange({ target: { name: "address", value: street } });
      handleFormChange({ target: { name: "city", value: city } });
      handleFormChange({
        target: {
          name: "state_id",
          value: state ? state.id : "",
        },
      });
      handleFormChange({
        target: {
          name: "dl_state_id",
          value: state ? state.id : "",
        },
      });
      handleFormChange({ target: { name: "zipcode", value: postalCode } });
      setAddressSelected(true);
    }
  };
  const removeAccents = (str) =>
    str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  return (
    <div>
      <GridItem xs={12} sm={12} md={12}>
        {open ? (
          <CustomDialog open={true} title={"Edit Quote"}></CustomDialog>
        ) : null}
        <div className={`${classesPrincipal.title} ${classesPrincipal.black}`}>
          {t("step2.title")}
        </div>
        <GridContainer style={{ marginTop: "20px" }}>
          <GridItem xs={12} sm={12} md={8}>
            <GridContainer>
              <GridItem xs={6} sm={6} md={6}>
                <CustomInput
                  labelText={t("step2.firstName")}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    required: true,
                    name: "first_name",
                    id: "first_nameStep2",
                    value: personData.first_name,
                    disabled: fieldEndorsement == "name" ? false : true,
                    onChange: handleFormChange,
                  }}
                />
              </GridItem>
              <GridItem xs={6} sm={6} md={6}>
                <CustomInput
                  labelText={t("step2.lastName")}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    required: true,
                    name: "last_name",
                    id: "last_nameStep2",
                    value: personData.last_name,
                    disabled: fieldEndorsement == "name" ? false : true,
                    onChange: handleFormChange,
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={6} sm={6} md={6}>
                <CustomInput
                  labelText={t("step2.dlNumber")}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    required: true,
                    name: "dl_number",
                    id: "dl_numberStep2",
                    value: personData.dl_number,
                    disabled: fieldEndorsement == "dl_license" ? false : true,
                    onChange: handleFormChange
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <CustomSelect
                  labelText={t("step2.dlCountry")}
                  menuItems={
                    data?.catalogs
                      ? data.catalogs.countries.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : []
                  }
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="dl_country_id"
                  value={personData.dl_country_id}
                  onChange={(e) => handleFormChange(e)}
                  inputProps={{
                    required: true,
                    name: "dl_country_id",
                    id: "dl_country_idStep2",
                    value: personData.dl_country_id,
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "dl_country" ? false : true,
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={12} md={6}>
                <CustomSelect
                  labelText={t("step2.dlState")}
                  menuItems={
                    dlstates
                      ? dlstates.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : []
                  }
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="dl_state_id"
                  value={personData.dl_state_id}
                  onChange={(e) => handleFormChange(e)}
                  inputProps={{
                    required: true,
                    name: "dl_state_id",
                    id: "dl_state_idStep2",
                    value: personData.dl_state_id,
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "dl_state" || fieldEndorsement == "dl_country" ? false : true,
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={8} sm={8} md={6}>
                <CustomSelect
                  labelText={t("step2.country")}
                  menuItems={
                    data?.catalogs
                      ? data.catalogs.countries.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : []
                  }
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="country_id"
                  onChange={(e) => handleFormChange(e)}
                  inputProps={{
                    required: true,
                    name: "country_id",
                    id: "country_idStep2",
                    value: personData.country_id,
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "country" ? false : true,
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={8}>
                <CustomInput
                  labelText={t("step2.street")}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    required: true,
                    name: "address",
                    id: "addressStep2",
                    value: personData.address,
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "address" ? false : true,
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelText={t("step2.aptUnit")}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    name: "aptUnit",
                    id: "aptUnitStep2",
                    value: personData.aptUnit,
                    onChange: handleFormChange,
                    placeholder: t("step2.optional"),
                    disabled: true,
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelText={t("step2.city")}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    required: true,
                    name: "city",
                    id: "cityStep2",
                    value: personData.city,
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "city" ? false : true,
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomSelect
                  labelText={t("step2.state")}
                  menuItems={
                    states
                      ? states.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : []
                  }
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="state_id"
                  onChange={(e) => handleFormChange(e)}
                  inputProps={{
                    required: true,
                    name: "state_id",
                    id: "state_idStep2",
                    value: personData.state_id,
                    onChange: handleFormChange,
                    disabled:
                      fieldEndorsement == "state" ||
                      fieldEndorsement == "country"
                        ? false
                        : true,
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                  labelText={t("step2.postalCode")}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    required: true,
                    name: "zipcode",
                    id: "zipcodeStep2",
                    value: personData.zipcode,
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "zipcode" ? false : true,
                  }}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={6} sm={6} md={6}>
                <CustomInput
                  labelText={t("step2.phone")}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    required: true,
                    name: "phone",
                    id: "phoneStep2",
                    value: personData.phone,
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "phone" ? false : true,
                  }}
                />
              </GridItem>
              <GridItem xs={6} sm={6} md={6}>
                <CustomInput
                  labelText={t("step2.email")}
                  type="email"
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    required: true,
                    type: "email",
                    name: "email",
                    id: "emailStep2",
                    value: personData.email,
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "email" ? false : true,
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={6} sm={6} md={6}>
                <CustomInput
                  labelText={t("step2.additionalInsured")}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  inputProps={{
                    name: "additionalInsured",
                    id: "additionalInsuredStep2",
                    value: personData.additionalInsured,
                    onChange: handleFormChange,
                    placeholder: t("step2.optional"),
                    disabled:
                      fieldEndorsement == "additionalInsured" ? false : true,
                    required: false,
                  }}
                />
              </GridItem>
              <GridItem
                xs={6}
                sm={6}
                md={6}
                style={{
                  display: ["3", null].includes(
                    localStorage.getItem("userType")
                  )
                    ? "none"
                    : "block",
                }}
              >
                <CustomSelect
                  labelText={t("step2.preferredLanguage")}
                  menuItems={[
                    {
                      value: "",
                      label: t("step2.preferredLanguage"),
                    },
                    {
                      value: "en",
                      label: "English",
                    },
                    {
                      value: "es",
                      label: "Español",
                    },
                  ]}
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="preferred_language"
                  value={preferredLanguage}
                  inputProps={{
                    required: true,
                    name: "preferred_language",
                    id: "preferred_languageStep2",
                    value: preferredLanguage,
                    onChange: (e) => {
                      setPreferredLanguage(e.target.value);
                    },
                    disabled: true,
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer
              container
              justifyContent="space-between"
              alignItems="center"
              style={{ minHeight: "100px", marginTop: "20px" }}
            >
              <GridItem xs={4}>
                <Button
                  id={isLogged ? "previousStep1" : "previousStep1Guest"}
                  onClick={handlePreviewAction}
                  variant="white"
                  style={{ width: "100%" }}
                >
                  {t("common.previous")}
                </Button>
              </GridItem>
              <GridItem xs={4} />
              <GridItem xs={4}>
                <Button
                  id={isLogged ? "continueStep2" : "continueStep2Guest"}
                  type="submit"
                  onClick={(event) => {
                    handleSubmitStep();
                  }}
                  disabled={!isCompleted}
                  variant="green"
                  style={{ width: "100%" }}
                >
                  {t("common.continue")}
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
        <CustomModal
          title="Attention"
          isOpen={modalDriverExists}
          onClose={() => setModalDriverExists(false)}
          privacy={false}
          id={"modalDriverExists"}
        >
          <GridContainer>
            <GridItem xs={12}>
              <p style={{ fontSize: "15px", color: "Red !important" }}>
                <div>{messageModalCheck}</div>
              </p>
            </GridItem>
          </GridContainer>
          <GridContainer>
            {!isAgent ? (
              <>
                <GridItem xs={6}>
                  <CustomButton
                    id="checkDriverLoginButton"
                    type="submit"
                    variant="red"
                    block
                    onClick={() => {
                      window.location.href = "/auth/login-customer";
                    }}
                  >
                    Login
                  </CustomButton>
                </GridItem>
                <GridItem xs={6}>
                  <CustomButton
                    id="checkDriverButton"
                    type="button"
                    variant="green"
                    onClick={() => {
                      setMessageModalCheck("");
                      setModalDriverExists(false);
                      setCheckedAccountStep(true);
                    }}
                    block
                  >
                    Continue as guest
                  </CustomButton>
                </GridItem>
              </>
            ) : (
              <GridItem xs={12}>
                <CustomButton
                  id="checkDriverAgentButton"
                  type="button"
                  variant="green"
                  onClick={() => {
                    setModalDriverExists(false);
                  }}
                  block
                >
                  OK
                </CustomButton>
              </GridItem>
            )}
          </GridContainer>
        </CustomModal>
      </GridItem>
    </div>
  );
});

Step1.displayName = "Step1";

export default Step1;
